/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

// Framer Motion does not export prop types so these just create a named
// variable to make components more readable and to satisfy linters.

// An object returned by useAnimation().
export const animationControlsPropTypes = PropTypes.object;
